import { ContentTypePoolRecipeDtoType } from 'types/services/magnolia/dtos/ContentTypePoolRecipeDto';

export const getTagIds = (item: ContentTypePoolRecipeDtoType, selectedTag: string): string[] => {
	const tags: Array<{ id: string }> = item.tags[selectedTag] || [];
	return tags.map((tag: { id: string }) => tag.id);
};

export const filterForTag = (item: ContentTypePoolRecipeDtoType, selectedTag: string, lookup: string): boolean => {
	return !!~getTagIds(item, selectedTag).indexOf(lookup);
};
